export default {
  Nödvändiga: 'C0001',
  Statistiska: 'C0002',
  Funktionella: 'C0003',
  Annonsering: 'C0004',
} as const;
